<ion-toolbar color="--ion-color-light-teal-2" class="ion-text-center" style="background-color: rgba(54, 73, 109, 1)">
      <ion-title class="help-info-title">Help</ion-title>
</ion-toolbar>

<ion-content class="white">
    <ion-row class="white">
        <ion-col size="12">
            <ion-row>
                <!-- <ion-col class="text-center" size="12">
                    <fa-icon class="info-icon" [icon]="faInfoCircle"></fa-icon>
                </ion-col> -->
                <ion-col size="12" class="ion-text-center">
                    <!-- assets/icons/logo_orange.png -->
                    <a href="https://www.youtube.com/watch?v=qbZTAEdw6J4" target="_blank">
                    <img src="../../../../../assets/video_image.png">   
                    </a>                 
                    <ion-text>
                        <p class="help-info-text">
                            How to filter and sort by for best search results
                        </p>
                        <div class="help-info-divider">
                                <p class="help-info-heading">FAQ and Support</p>
                        </div>
                        <div class="help-info">
                            <p class="help-info-sub-heading">Contact Us</p>
                            <div class="help-info-details-container">
                                <p class="help-info-details">
                                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" style="vertical-align: -0.125em;" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 512 512"><g transform="translate(512 0) scale(-1 1)"><rect width="416" height="320" x="48" y="96" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" rx="40" ry="40"/><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="m112 160l144 112l144-112"/></g></svg>
                                    Email <a class="help-info-details-link" href="mailto:advisors@amopportunities.org">advisors&#64;amopportunities.org</a></p>
                                <p class="help-info-details">
                                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" style="vertical-align: -0.125em;" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 512 512"><g transform="translate(512 0) scale(-1 1)"><path fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="32" d="M451 374c-15.88-16-54.34-39.35-73-48.76c-24.3-12.24-26.3-13.24-45.4.95c-12.74 9.47-21.21 17.93-36.12 14.75s-47.31-21.11-75.68-49.39s-47.34-61.62-50.53-76.48s5.41-23.23 14.79-36c13.22-18 12.22-21 .92-45.3c-8.81-18.9-32.84-57-48.9-72.8C119.9 44 119.9 47 108.83 51.6A160.15 160.15 0 0 0 83 65.37C67 76 58.12 84.83 51.91 98.1s-9 44.38 23.07 102.64s54.57 88.05 101.14 134.49S258.5 406.64 310.85 436c64.76 36.27 89.6 29.2 102.91 23s22.18-15 32.83-31a159.09 159.09 0 0 0 13.8-25.8C465 391.17 468 391.17 451 374Z"/></g></svg>
                                    Phone <a class="help-info-details-link" href="tel:+1-312-821-9020">+ 1-312-821-9020</a></p>
                                <p class="help-info-details-link">Schedule a call with an AMO Advisor today.</p>
                            </div>
                        </div>
                    </ion-text>
                </ion-col>
            </ion-row>
        </ion-col>
    </ion-row>
</ion-content>

<ion-footer class="ion-no-border ion-text-center">
    <!-- <ion-button
        class="btncta ion-margin-bottom add-width"
        id="itineraryInfoDismissBtn"
        mode="md"
        fill="solid"
        color="secondary"
        type="button"
        (click)="ctaClick()"
    >
        Got it!
    </ion-button> -->
    <!-- <ion-title>Schedule a call with an AMO Advisor today.</ion-title> -->
</ion-footer>
